<template>
    <div class="ARL">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="modal" :title="info.label">
            <div class="info-wrapper align-items-center">
                <img :src="info.img" alt="">
                <div><p v-for="(item, index) in info.p" :key="index"><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>{{item}}</p></div>
            </div>
        </b-modal>
        <div class="title">
            <span>Seguros</span>
            <h1>ARL</h1>
            <div id="contactForm">
                <label for="">Conoce más sobre soluciones de seguros</label>
                <div id="hubcontactForm"></div>
            </div>
        </div>
        <div class="info top">
            <h1>Seguro ARL</h1>
            <p>Te brindamos el control de tu ARL mediante la administración del SG-SST</p>
        </div>
        <div class="banner-info">
            <center>
                <img src="@/assets/Seguros-arl/img-servicios-arl.png" alt="">
                <div>
                <p>Si tu compañía NO cuenta con el responsable en el SG-SST con nuestro producto GEA
                    SST (Gestionamos, Ejecutamos y Administramos la Seguridad y salud en el Trabajo) te
                    guiamos con la responsabilidad de este proceso como complemento de tus recursos de tu
                    ARL (Administradora de Riesgos Laborales).
                </p>
                <p>Te brindaremos estos requisitos de ley acorde a tus recursos de ARL, Adicional contaras
                    con nuestro aplicativo web y App para que gestiones tu SG-SST en tiempo real</p>
                </div>
            </center>
        </div>
        <div class="sst">
            <!-- eslint-disable -->
            <center>
                <div v-for="(items, index) in sst.map((item, index) => {if(index % 2===0)return [item, sst[++index]]})" :key="index" v-if="items" :class="{'rigth': index % 4 !== 0}">
                    <div :class="{'rigth': index % 4 !== 0} || {'left': index % 4 === 0}">
                        <img v-if="index === sst.length - 1" :src="items[0].img" @click="open">
                        <div v-for="(info, yendex) in items" :key="yendex" v-if="index < sst.length - 1 && info">
                            <div>
                                <center><div><img :src="info.icon" alt=""></div>
                                <label for="">{{info.title}}</label></center>
                                <p>{{info.text}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
            <!-- eslint-enable -->
        </div>
        <div class="texto">
            <h2>Conoce nuestro modelo de acompañamiento Outsourcing SST</h2>
            <p>Acorde a tu recurso de ARL, pondremos a tu disposición nuestra gama de profesionales en
            seguridad y salud en el trabajo con su licencia en SST, para que se sume a tu equipo de
            trabajo como complemento al área de SST.
            </p>
            <p>Nuestra modalidad Outsourcing SST es creada para ti con el propósito de trabajar de la
            mano con tu equipo para hacer crecer tu empresa cuidando tu mejor activo. TÚ SUEÑO</p>
            <center class="box" v-for="(item, index) in boxs" :key="index">
                <div class="icon"><div><img :src="item.icon" alt=""></div></div>
                <div class="items">
                    <label for="">{{item.label}}</label>
                    <div v-for="(info, yendex) in item.p" :key="yendex">
                        <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                        <p>{{info}}</p>
                    </div>
                </div>
            </center>
        </div>
        <div class="especialidades">
            <center>
                <h2>Explora nuestra gama de Especialidades SST</h2>
                <div>
                    <div v-for="(item, index) in especialidades" :key="index">
                        <div>
                            <div>
                                <label for="">{{item.label}}</label>
                                <div><button @click="openModal(item)">VER MÁS</button></div>
                            </div>
                            <img :src="item.img" alt="">
                        </div>
                    </div>
                </div>
            </center>
        </div>
    </div>
</template>

<script>
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Slick from 'vue-slick'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'ARL',
    metaInfo() {
        return {
            title: 'Seguros ARL',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Te brindaremos estos requisitos de ley acorde a tus recursos de ARL, Adicional contaras con nuestro aplicativo web y App para que gestiones tu SG-SST en tiempo real'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    data() {
        return {
            especialidades: [
                {
                    id: 1,
                    label: 'Explora nuestra gama de Especialidades SST',
                    img: require('@/assets/Seguros-arl/Especialidades/digital-sst.png'),
                    p: [
                        'Automatización digital en SST',
                        'Automatización digital con aplicativo Web para la administración, ejecución y control del sistema de gestión en seguridad y salud en el trabajo.',
                        'Conoce los diferentes planes en aquí'
                    ]
                },
                {
                    id: 1,
                    label: 'SISTEMAS DE GESTIÓN',
                    img: require('@/assets/Seguros-arl/Especialidades/sistema-gestion.png'),
                    p: [
                        'Auditoría Legal en Seguridad y Salud en el Trabajo (Decreto 1072 de 2015)',
                        'Asesoría en el Cierre de No Conformidades a los Sistemas de Gestión.',
                        'Auditorías externas para procesos de certificación en ISO, Calidad, Ambiente y Seguridad y Salud en el Trabajo.',
                        'Implementación de los Sistemas de Gestión ISO 9001 – ISO 14001 – ISO 31000 – ISO 45001 – RUC “Procesos de certificación y acompañamiento externo”.'
                    ]
                },
                {
                    id: 1,
                    label: 'PLAN LEGAL',
                    img: require('@/assets/Seguros-arl/Especialidades/legal.png'),
                    p: [
                        'Auditoría en los estándares mínimos según lineamientos MINISTERIO DE TRABAJO Res. 0312 de 2019.',
                        'Asesoría en Responsabilidad Legal laboral basado en el Sistema General de Riesgos Laborales. “Matrices Legales”.',
                        'Entrenamiento y estructuración del Comité Paritario en Seguridad y Salud en el Trabajo(COPASST).',
                        'Diseño del Reglamento de Higiene y Seguridad Industrial.',
                        'Diseño en la elaboración de la Política de Seguridad y Salud en el Trabajo.',
                        'Diseño en el Procedimiento para Notificación e Investigación de Accidentes de Trabajo. Res. 1401 del 2007 “Metodologías de Investigación”.',
                        'Diseño de planes de trabajo de acuerdo al Sistema de Gestión de la Seguridad y Salud en el Trabajo.',
                        'Diseño del método para evaluar responsabilidades en Seguridad y Salud en el trabajosegún sea el cargo en la organización.',
                        'Diseño de plataforma de indicadores del sistema de gestión de seguridad y salud en el trabajo.'
                    ]
                },
                {
                    id: 1,
                    label: 'SEGURIDAD INDUSTRIAL',
                    img: require('@/assets/Seguros-arl/Especialidades/industrial.png'),
                    p: [
                        'Elaboración de matrices de peligros. GTC 45, HAZOP, AMFE, WHAT IF. PHA.',
                        'Ejecución de inspecciones de seguridad con indicadores de gestión. Modelo NTC 4114.',
                        'Diseño de planes de trabajo para prevención en accidentes de trabajo. Bajo Res. 1401 del 2007.',
                        'Asesoría en almacenamiento seguro y distribución de plantas. Standard OSHA.',
                        'Diseño de sistemas de almacenamiento y rotulado de sustancias químicas. NFPA 704, NTC 4435.',
                        'Asesoría en normalización de actividades y estándares de seguridad industrial. Modelo NTC 4116.',
                        'Diseño de matriz de elementos de protección personal. “Cargos o Proceso”. Investigación de accidentes de trabajo. MORTALES, GRAVES Según Res. 1401 del 2017, acompañamiento en auditoría por Inspectores de trabajo del Ministerio de Trabajo.',
                        'Investigación de accidentes de trabajo. MORTALES, GRAVES Según Res. 1401 del2017, acompañamiento en auditoría por Inspectores de trabajo del Ministerio de Trabajo.',
                        'Estudios de señalización en seguridad industrial.',
                        'Diseño de programa prevención de la accidentalidad basada en el comportamiento.',
                        'Estudios de señalización en seguridad industrial.'
                    ]
                },
                {
                    id: 1,
                    label: 'HIGIENE INDUSTRIAL',
                    img: require('@/assets/Seguros-arl/Especialidades/higiene-industrial.png'),
                    p: [
                        'Análisis de las Mediciones ocupacionales y controles de fuentes bajo diseño de sistemas de ingeniería.',
                        'Seguimiento a planes de acción para mejorar las condiciones higiénicas según resultados de las mediciones ocupacionales.',
                        'Desarrollo de Mediciones Ocupacionales. “Ruido, Iluminación, Confort térmicos, Vibraciones y material particulado.'
                    ]
                },
                {
                    id: 1,
                    label: 'MEDICINA PREVENTIVA DEL TRABAJO',
                    img: require('@/assets/Seguros-arl/Especialidades/medicina-preventiva.png'),
                    p: [
                        'Análisis de factores de riesgos psicosociales bajo Res. 2646 del 2008.',
                        'Desarrollo del programa de riesgo psicosocial.',
                        'Conformación del comité de convivencia laboral.',
                        'Aplicación de encuestas de baterías del Ministerio de Trabajo.',
                        'Intervención a los factores de riesgo psicosocial potencial.',
                        'Técnicas para el manejo del estrés.',
                        'Diseño de programas de vigilancia epidemiológica para los riesgos higiénicos propensos a enfermedades laborales.',
                        'Diseño de programa de prevención de lesiones osteomusculares.',
                        'Inspecciones de puesto de trabajo con énfasis osteomuscular. APT.',
                        'Análisis del ausentismo laboral.',
                        'Diseño de profesiogramas.',
                        'Diseño de procedimientos para exámenes médicos ocupacionales.'
                    ]
                },
                {
                    id: 1,
                    label: 'PLANES DE EMERGENCIA',
                    img: require('@/assets/Seguros-arl/Especialidades/plan-emergencia.png'),
                    p: [
                        'Diseño y aplicación de Sistema de Comando de Incidentes.',
                        'Diseño de planes de prevención, preparación y atención de emergencias.',
                        'Diseños de procedimientos operativos normalizados.',
                        'Diseño de planes de atención de incidentes.',
                        'Asesoría en identificación, análisis de amenazas y de vulnerabilidad.',
                        'Conformación de la brigada de emergencias.',
                        'Diseño de programas de formación a la brigada de emergencias.',
                        'Formación de brigadas de emergencias. BÁSICAS, INTERMEDIAS, AVANZADAS.',
                        'Diseño de plan de emergencias químicas.',
                        'Diseño en planes de contingencias.',
                        'Estudios de necesidades de señalización de emergencias.',
                        'Auditorías a planes de emergencias.',
                        'Simulacros de emergencias',
                        'Control del riesgo ofídico.',
                        'Asesoría en el manejo de hojas de seguridad (msds) y tarjetas de emergencia'
                    ]
                },
                {
                    id: 1,
                    label: 'PROGRAMAS DE PREVENCIÓN Y CONTROL DE TAREAS CRÍTICAS',
                    img: require('@/assets/Seguros-arl/Especialidades/control-criticas.png'),
                    p: [
                        'Diseño de programas de gestión para tareas de alto riesgo (trabajos en alturas, espacios confinados, trabajo en caliente y aseguramiento de energías peligrosas, excavaciones, izaje de cargas, riesgo público y maquinaria pesada).',
                        'Diseño del modelo de permisos de trabajo según la actividad de alto riesgo.',
                        'Análisis de tareas críticas y modelos de intervención.',
                        'Diseño en el programa transporte seguro de valores',
                        'Diseño programa seguro en alturas (certificación trabajo seguro en alturas) e identificación de dispositivos de seguridad. Res. 1409 del 2012.',
                        'Diseño de programa de seguridad vial. Res. 1565 del 2014.'
                    ]
                },
                {
                    id: 1,
                    label: 'FORMACIÓN Y CAPACITACIÓN',
                    img: require('@/assets/Seguros-arl/Especialidades/capacitacion.png'),
                    p: [
                        'Capacitación en seguridad industrial; Riesgos mecánicos, riesgos locativos, riesgoseléctricos, riesgos públicos, riesgo de tránsito y riesgo químico.',
                        'Capacitación en higiene industrial; Riesgos biomecánicos, riesgos físicos y riesgosquímicos.',
                        'Capacitación en planes de emergencias; primeros auxilios, prácticas bomberiles, evacuación, búsqueda y rescate, sistema de comando incidentes.',
                        'Seminarios en sistemas de gestión en seguridad y salud en el trabajo.',
                        'Curso de auditoría en sistema de gestión de seguridad y salud en el trabajo.',
                        'Formación en trabajo seguro en alturas según Res. 1409 del 2012.'
                    ]
                },
                {
                    id: 1,
                    label: 'COACHING EN SST',
                    img: require('@/assets/Seguros-arl/Especialidades/coaching-sst.png'),
                    p: [
                        'Prevenir accidentes por medio de la concienciación y el amor a la vida y la familia.',
                        'Fomentar una cultura fuerte en seguridad en todas las actividades, haciendo que ésta una prioridad y posicionando la estrategia como un compromiso permanente, individual y común.',
                        'Generar comportamientos conscientes para automatizar las actividades cotidianas yconvertir cada una de éstas en estados presenciales del ser viviendo aquí y ahora.',
                        'Influenciar los comportamientos a riesgo del grupo, mediante el ejemplo en todos los niveles y procesos de la organización.',
                        'Fortalecer la conciencia en la identificación de peligros, riesgos y controles.',
                        'Implementar manifestaciones visibles y evaluar las acciones coherentes del compromiso consciente para modificar el comportamiento riesgoso de las personas.',
                        'Generar una conciencia consciente en todos los aspectos de la vida de cada participante “creando un mejor futuro aquí y ahora ”, a través de la metodología “MINDFULNESS” o conciencia plena ( AQUÍ Y AHORA).'
                    ]
                }
            ],
            sst: [
                {
                    title: 'Evaluación inicial del SG-SST',
                    icon: require('@/assets/Seguros-arl/Iconos/1.png'),
                    text: 'según la Resolución 0312 del 2019, que establece la evaluación de los estándares mínimos en seguridad y salud en el trabajo.'
                },
                {
                    title: 'Formulación de políticas en SST',
                    icon: require('@/assets/Seguros-arl/Iconos/2.png'),
                    text: 'Adaptamos e implementaremos tus políticas para el compromiso de tu empresa y tustrabajadores en SST.'
                },
                {
                    title: 'Plan anual de trabajo',
                    icon: require('@/assets/Seguros-arl/Iconos/3.png'),
                    text: 'Te estructuramos el plan de actividades para la gestión del SG-SST.'
                },
                {
                    title: 'Matriz legal',
                    icon: require('@/assets/Seguros-arl/Iconos/4.png'),
                    text: 'estableceremos el marco legal que te aplica según tu actividad económica y procesosdesarrollados.'
                },
                {
                    title: 'Matriz de identificación y evaluación de peligros',
                    icon: require('@/assets/Seguros-arl/Iconos/5.png'),
                    text: 'de acuerdo a tus procesos desarrollados te apoyaremos en la identificación y evaluación de tusriesgos.'
                },
                {
                    title: 'Programas de gestión',
                    icon: require('@/assets/Seguros-arl/Iconos/6.png'),
                    text: 'de acuerdo a los procesos críticos que desarrolles te estableceremos qué programas de gestión enfocados al riesgo se deben establecer.'
                },
                {
                    title: 'Plan de prevención',
                    icon: require('@/assets/Seguros-arl/Iconos/7.png'),
                    text: 'preparación y respuesta de emergencias, según la ubicación geográfica, los procesos desarrollados establecerán los preámbulos para el control de las amenazas y la prevención de emergencias.'
                },
                {
                    title: 'Investigación de accidentes de trabajo y enfermedades laborales',
                    icon: require('@/assets/Seguros-arl/Iconos/8.png'),
                    text: 'te guiaremos en el proceso legal que se debe cumplir para ATEL.'
                },
                {
                    title: 'Plan de mejora',
                    icon: require('@/assets/Seguros-arl/Iconos/9.png'),
                    text: 'te entregaremos qué prioridades se deben establecer para la disminución del riesgo legal.'
                },
                {
                    title: 'Documentación del SG-SST, en las fases PHVA',
                    icon: require('@/assets/Seguros-arl/Iconos/9.png'),
                    text: 'PLANEAR, HACER, VERIFICAR Y ACTUAR'
                },
                {
                    img: require('@/assets/Seguros-arl/aplicativo-web.png')
                }
            ],
            boxs: [
                {
                    icon: require('@/assets/Seguros-arl/Iconos/1.png'),
                    label: 'Técnicos en seguridad y salud en el trabajo o su equivalente',
                    p: [
                        'Educación',
                        'Capacitación',
                        'Diseño, administración y ejecución del sistema de gestión de la seguridad y salud en el trabajo'
                    ]
                },
                {
                    icon: require('@/assets/Seguros-arl/Iconos/1.png'),
                    label: 'Ingeniero(a) en todas las disciplinas, especialistas en un área de seguridad y salud en el trabajo o equivalente:',
                    p: [
                        'Ingeniería en seguridad y salud en el trabajo o su equivalente',
                        'Higiene y seguridad industrial, cuando lo acredite en su formación de posgrado',
                        'Investigación de área técnica',
                        'Investigación del accidente de trabajo de acuerdo con su competencia segúnformación académica',
                        'Educación',
                        'Capacitación',
                        'Diseño, administración y ejecución del sistema de gestión de la seguridad y salud en el trabajo'
                    ]
                },
                {
                    icon: require('@/assets/Seguros-arl/Iconos/1.png'),
                    label: 'Otros profesionales con especialización en seguridad y salud en el trabajo o alguna de sus áreas:',
                    p: [
                        'Profesión en seguridad y salud en el trabajo',
                        'Investigación en área técnica',
                        'Investigación del occidente de acuerdo con su competencia según formación académica',
                        'Educación',
                        'Capacitación',
                        'Diseño, administración y ejecución del sistema de gestión de la seguridad y salud en el trabajo'
                    ]
                },
                {
                    icon: require('@/assets/Seguros-arl/Iconos/1.png'),
                    label: 'Profesionales en seguridad y salud en el trabajo o equivalente:',
                    p: [
                        'Profesión en seguridad y salud en el trabajo o su equivalente',
                        'Higiene industrial, cuando lo acredite en su formación',
                        'Seguridad industrial, cuando lo acredite en su formación',
                        'Investigación del accidente de trabajo',
                        'Educación',
                        'Capacitación',
                        'Diseño, administración y ejecución del sistema de gestión de la seguridad y salud en el trabajo'
                    ]
                }
            ],
            info: {}
        }
    },
    components: {
        Footer,
        Header,
        Slick,
        VueSlickCarousel
    },
    methods: {
        open() {
            window.open('http://interlaborales.nygsst.com/', '_blank')
        },
        openModal(info) {
            this.info = info
            this.$refs.modal.show()
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style scoped>
    .arl {
        margin: 0;
        padding: 0;
    }
    .title {
        background-image: url('../../assets/Seguros-arl/Banner-top-arl.jpg');
        padding: 200px 200px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto 100%;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        width: 60%;
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 200px;
        font-size: 40px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 200px;
        margin-top: 10px;
        font-size: 30px;
    }
    .banner-info {
        background: linear-gradient(90deg, rgba(233,254,254,1) 0%, rgba(211,255,202,1) 100%);
        padding: 50px 200px 50px 200px;
    }
    .banner-info > center > div {
        width: 65%;
        text-align: justify;
    }
    .sst {
        padding: 20px 150px 50px 150px;
        background: #f8f9fb;
        width: 100%;
    }
    .sst  > center {
        width: 100%;
    }
    .sst  > center > div {
        display: inline-flex;
        width: 50%;
    }
    .sst  > center > div.rigth {
        float: right;
    }
    .sst > center > div > div {
        display: flex;
        width: 100%;
    }
    .sst > center > div > div > img {
        width: 100%;
    }
    .sst  > center > div > div.rigth {
        float: right;
    }
    .sst  > center > div > div.left {
        float: left;
    }
    .sst  > center > div > div > div {
        background-color: #fff;
        margin: 10px;
        width: 50%;
        height: 400px;
        position: relative;
        border-radius: 20px;
        -webkit-box-shadow: 0px 0px 21px -2px rgba(0,0,0,0.20);
        -moz-box-shadow: 0px 0px 21px -2px rgba(0,0,0,0.20);
        box-shadow: 0px 0px 21px -2px rgba(0,0,0,0.20);
    }
    .sst > center > div > div > div > div {
       position: absolute;
       left: 50%;
       transform: translate(-50%,-50%);
        text-align: justify;
        width: 100%;
        height: 100%;
        padding: 30px;
       top: 50%;
   }
   .sst > center > div > div > div > div > center > div{
        margin-bottom: 30px;
   }
   .sst > center > div > div > div > div > center > div {
        width: 75px;
        height: 75px;
        background: -webkit-gradient(linear, left top, right bottom, from(#65b24a), to(#2d4f98));
        background: linear-gradient(to bottom right, #65b24a, #2d4f98);
        border-radius: 50%;
        position: relative;
   }
   .sst > center > div > div > div > div > center > div > img{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
   }
   .sst > center > div > div > div > div > center > div > img{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
   }
   .sst > center > div > div > div > div > center > label{
        color: #2d4f98;
        font-size: 24px;
        font-family: 'JBD';
   }
    .texto {
        width: 100%;
        padding: 60px 250px;
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
        display: flex;
        position: relative;
    }
    .texto > .box > .icon {
        position: relative;
        width: 10%;
    }
    .texto > .box > .icon > div  {
        background: -webkit-gradient(linear, left top, right bottom, from(#65b24a), to(#2d4f98));
        background: linear-gradient(to bottom right, #65b24a, #2d4f98);
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 15px;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }
    .texto > .box > .items {
        position: relative;
        width: 90%;
        height: 100%;
        padding-left: 50px;
    }
    .texto > .box > .items > label{
        margin-left: 20px;
        color: #65b24a;
        font-family: 'JBD';
    }
    .texto > p {
        font-family: 'JR';
    }
    .texto > h2{
        color: #2d4f98;
        margin-bottom: 60px;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
        font-size: 20px;
    }
    .especialidades {
        background: rgb(244,228,252);
        background: linear-gradient(90deg, rgba(244,228,252,1) 0%, rgba(203,231,255,1) 100%);
        padding-top: 60px;
        padding-bottom: 60px;
    }
    .especialidades > center > h2 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .especialidades > center > h2 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .especialidades > center > div {
        min-height: 700px;
        width: 100%;
        display: grid;
        grid-template-columns: auto auto auto auto auto;
        justify-content: center;
    }
    .especialidades > center > div > div{
        position: relative;
        width: 330px;
        height: 330px;
    }
    .especialidades > center > div > div.left{
        float: left;
    }
    .especialidades > center > div > div > div {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .especialidades > center > div > div > div > img{
        width: 100%;
        height: 100%;
    }
    .especialidades > center > div > div > div > div {
        position: absolute;
        display: block;
        left: 50px;
        top: 120px;
    }
    .especialidades > center > div > div > div > div > label{
        width: 200px;
        z-index: 99999999;
        left: 50px;
        top: 100px;
        text-align: left;
        color: #FFF;
        font-size: 21px;
        font-family: 'JBD';
    }
    .especialidades > center > div > div > div > div > div {
        position: relative;
    }
    .especialidades > center > div > div > div > div > div > button{
        position: absolute;
        font-family: 'JR';
        background-color: #65b24a;
        width: auto;
        height: auto;
        border-radius: 20px;
        border-color: #65b24a;
        border-style: solid;
        font-size: 12px;
        color: #fff;
        text-align: left;
        left: 0;
    }
    .info-wrapper {
        display: flex;
    }
    @media (max-width: 1700px) {
        .especialidades > center > div {
            grid-template-columns: auto auto auto auto;
            justify-content: center;
        }
    }
    @media (max-width: 1400px) {
        .banner-info {
            padding: 50px 150px 50px 150px;
        }
        .sst {
            padding: 20px 75px 50px 75px;
        }
        .texto {
            padding: 60px 200px;
        }
        .especialidades > center > div {
            grid-template-columns: auto auto auto;
            justify-content: center;
        }
    }
    @media (max-width: 1300px) {
        .banner-info {
            padding: 50px 100px 50px 100px;
        }
    }
    @media (max-width: 1200px) {
        .banner-info {
            padding: 50px 50px 50px 50px;
        }
        .sst > center > div {
            display: block;
            width: 70%;
        }
        .sst > center > div.rigth {
            float: none;
        }
        .info {
            width: 80%;
        }
    }
    @media (max-width: 1100px) {
        .banner-info > center > img {
            width: 100%;
        }
        .banner-info > center > div {
            width: 90%;
        }
        .texto {
            padding: 60px 100px;
        }
        .especialidades > center > div {
            grid-template-columns: auto auto;
            justify-content: center;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 200px 50px 200px 50px;
            background-attachment: fixed;
            background-position: bottom;
            background-size: auto 100%;
        }
        .info {
            margin-top: 150px;
            width: 100%;
            text-align: center;
        }
        .sst > center > div {
            width: 80%;
        }
    }
    @media (max-width: 900px) {
        .sst > center > div {
            width: 90%;
        }
        .info {
            margin-top: 280px;
            width: 100%;
            text-align: center;
            padding: 50px 50px 50px 50px;
        }
        .info > h1 {
            padding-left: 0px;
            width: 100%;
            text-align: center;
        }
        .info > p {
            padding-left: 0px;
            width: 100%;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .title  {
            text-align: center;
        }
    }
    @media (max-width: 800px) {
        .sst > center > div {
            width: 100%;
        }
        .sst > center > div > div {
            display: block;
        }
        .sst > center > div > div.rigth {
            float: none;
        }
        .sst > center > div > div.left {
            float: none;
        }
        .sst > center > div > div > div {
            width: 70%;
        }
    }
    @media (max-width: 700px) {
        .texto {
            padding: 60px 25px;
        }
        .especialidades > center > div {
            grid-template-columns: auto;
            justify-content: center;
        }
    }
    @media (max-width: 600px) {
        #contactForm {
            width: 350px;
        }
        .sst > center > div > div > div {
            width: 80%;
        }
        .sst {
            padding: 20px 50px 50px 50px;
        }
        .texto > .box {
            display: block;
        }
        .texto > .box > .icon {
            width: 100%;
            height: 100px;
        }
        .texto > .box > .items {
            width: 100%;
            padding-left: 0px;
        }
    }
    @media (max-width: 500px) {
        #contactForm {
            width: 350px;
        }
        .sst > center > div > div > div {
            width: 100%;
        }
        .sst {
            padding: 20px 25px 50px 25px;
        }
    }
    @media (max-width: 400px) {
        #contactForm {
            width: 300px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/Arl.vue